module.exports = __webpack_public_path__ + "img/刘凤岩@2x.6cd9f322.png";